import React, { useState } from 'react';
import { Button, Form, Input, Card, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { RegisterQuery } from '../shared/common/graphqlQuery';
// import { RegisterUser } from '../common/interfaces';
import { useMutationHook } from '../shared/hooks/useMutationHook';
import { Brand_Name, routeConfig } from '../shared/common/constant';
import { validateNameMessages } from '../shared/hooks/utils';
import AccountPageShowBrand from '../shared/components/accountPageShowBrand/accountPageBrand';

const Register = () => {

    const [registerError, setRegisterError] = useState<string>('');
    const [isRegistered, setIsRegistered] = useState(false);
    const [userEmail, setUserEmail] = useState<any>('');

    const onSubmitted = (result: any) => {
        setIsRegistered(true);
    }
    const onError = ({ graphQLErrors, networkError }: any) => {
        console.log(graphQLErrors[0].message, 'error');
        if (graphQLErrors[0].message === 'USER_ALREADY_EXISTS') {
            setRegisterError('USER ALREADY EXISTS');
        }
    }
    const { callMutation, loading } = useMutationHook(RegisterQuery, onSubmitted, onError);

    const onFinish = (values: any) => {
        if (!loading) {
            values.membershipStatus = 1;
            values.email = values.email.toLowerCase();
            setUserEmail(values);
            callMutation({ variables: { userInput: { ...values } } });
        }
        // message.info('We will be allowing new users soon!');
    }
    return (
        <div className="center">
            <div className="card">
                <AccountPageShowBrand />
                {
                    isRegistered ?
                        <Card bordered={false} className='loginForm' >
                            <div>
                                Hi <strong>{userEmail.name}</strong>, Welcome to <strong>{Brand_Name}</strong>.
                            </div>
                            <br/>
                            <div>
                                A Verification link has been sent to your email account.
                                Please click on it and continue the registration process.
                            </div>
                        </Card> :
                        <Card title="Create an Export Docs account today" bordered={false} className='loginForm'>
                            <Form name="basic" onFinish={onFinish} validateMessages={validateNameMessages} >
                                <Form.Item name="name" rules={[{ required: true }]} >
                                    <Input size="large" placeholder="Name" />
                                </Form.Item>
                                <Form.Item name="email" rules={[{ required: true, whitespace: true, type: 'email' }]} >
                                    <Input size="large" placeholder="E-mail" />
                                </Form.Item>
                                <Form.Item name="password" rules={[{ required: true, whitespace: true }]} >
                                    <Input.Password size="large" placeholder="Password" />
                                </Form.Item>
                                <Form.Item>
                                    <Button size="large" type="primary" htmlType="submit" style={{ width: '100%' }}>
                                        {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Sign up'}
                                    </Button>
                                </Form.Item>
                                {registerError ? <div className="error__color error__align">{registerError}</div> : ''}
                                <div className="sign-up">
                                    Already a user?<Button type="link"><Link to={routeConfig.login.path}>Sign In</Link></Button>
                                </div>
                            </Form>
                        </Card>
                }
            </div>
        </div >
    );
}
export default Register;
